
function Display({text}) { 
    return <div id="display">{text}</div>;
}
export default Display;